import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import LoginForm from "../components/loginform";
import { API_BASE } from "../utils/draftutils"; // <<< aggiunto

function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [isConfigurator, setIsConfigurator] = useState(false);
  const [message, setMessage] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const flash = sessionStorage.getItem("flashMessage");
    if (flash) {
      setMessage(flash);
      sessionStorage.removeItem("flashMessage");
      return;
    }

    const success = location.state?.successMessage;
    if (success) {
      setMessage(success);
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, location.pathname, navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const response = await fetch(`${API_BASE}/api/auth/login`, { 
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          username,
          password,
          tipoUtente: isConfigurator ? "CONFIGURATORE" : "FRUITORE"
        }),
      });

      const result = await response.json();
      if (response.ok) {
        setMessage(result.message);

        if (result.tipoUtente === "CONFIGURATORE") {
          navigate("/menuconfig");
        } else if (result.tipoUtente === "FRUITORE") {
          navigate("/menufruitore");
        } else {
          setMessage("Errore");
        }
      } else {
        setMessage(result.message);
      }
    } catch (error) {
      console.error("Errore nel login", error);
      setMessage("Errore di connessione al server");
    }
  };

  return (
    <LoginForm
      username={username}
      setUsername={setUsername}
      password={password}
      setPassword={setPassword}
      onSubmit={handleLogin}
      isConfigurator={isConfigurator}
      setIsConfigurator={setIsConfigurator}
      message={message}
    />
  );
}

export default Login;
